<template>
  <li class="search-result-item">
    <a
      href="#"
      class="result"
      v-html="keywordHtml"
      @click.prevent="() => emits('select', keyword)"
    >
    </a>
  </li>
</template>
<script setup>
import { onMounted, defineProps, computed, defineEmits } from "vue";

const emits = defineEmits(["select"]);

const props = defineProps({
  keyword: {
    type: String,
    default: "",
  },
  shwrd: {
    type: String,
    default: "",
  },
});

onMounted(() => {});

const keywordHtml = computed(() => {
  return props.keyword
    .split(props.shwrd.toUpperCase())
    .join(`<span class="color-primary">${props.shwrd.toUpperCase()}</span>`);
});
</script>
